import React, { useState } from 'react';

export const expertiseData = [
  {
    title: 'AI Engineering',
    description: 'Build intelligent, production-ready AI solutions that deliver measurable business value.',
    icon: 'fa-solid fa-brain',
    capabilities: ['Generative AI', 'Large Language Models', 'AI Agents', 'RAG', 'AI Chatbots', 'Document Intelligence', 'Multimodal AI', 'AI API Integration'],
    technologies: ['OpenAI', 'LLMs', 'RAG', 'LangChain', 'LlamaIndex', 'AI Agents', 'Vector DB', 'Python'],
  },
  {
    title: 'Machine Learning',
    description: 'Turn raw data into predictive intelligence with production-grade machine learning models that drive smarter decisions.',
    icon: 'fa-solid fa-chart-line',
    capabilities: ['Predictive Analytics', 'Demand Forecasting', 'Recommendation Systems', 'Risk Prediction', 'Fraud Detection', 'Anomaly Detection', 'Time-Series Forecasting', 'Customer Churn Prediction'],
    technologies: ['Python', 'Scikit-learn', 'XGBoost', 'TensorFlow', 'PyTorch', 'MLflow'],
  },
  {
    title: 'Data Engineering',
    description: 'Build resilient, scalable data pipelines that turn raw data into a trusted, business-ready foundation.',
    icon: 'fa-solid fa-database',
    capabilities: ['ETL / ELT', 'Data Pipeline Development', 'Data Integration', 'Data Modernization', 'Real-time Processing', 'Data Lakehouse Architecture', 'Data Quality', 'Data Governance'],
    technologies: ['AWS', 'Azure', 'GCP', 'Databricks', 'Spark', 'Airflow', 'Snowflake', 'BigQuery', 'SQL', 'NoSQL'],
  },
  {
    title: 'DevOps & Cloud Engineering',
    description: 'Automate infrastructure and streamline operations to ship software faster, safer, and at scale.',
    icon: 'fa-solid fa-cloud',
    capabilities: ['CI/CD', 'Infrastructure Automation', 'Cloud Infrastructure', 'Infrastructure as Code', 'Containerization', 'Kubernetes', 'Cloud Monitoring', 'Release Management'],
    technologies: ['Jenkins', 'GitLab', 'GitHub Actions', 'Terraform', 'Docker', 'Kubernetes', 'AWS', 'Azure', 'GCP'],
  },
  {
    title: 'Python & Ruby on Rails Development',
    description: 'Engineer robust, scalable applications and APIs that power your business from idea to launch.',
    icon: 'fa-solid fa-code',
    capabilities: ['Python', 'Django', 'FastAPI', 'Flask', 'Ruby', 'Ruby on Rails', 'REST APIs', 'Microservices', 'SaaS Development'],
    technologies: ['Python', 'Django', 'FastAPI', 'Flask', 'Ruby', 'Rails', 'REST API', 'Microservices'],
  },
  {
    title: 'Shopify & E-Commerce Development',
    description: 'Craft high-converting, custom-built storefronts that turn browsers into loyal, repeat customers.',
    icon: 'fa-solid fa-cart-shopping',
    capabilities: ['Shopify Development', 'Theme Customization', 'Shopify App Development', 'Shopify API Integration', 'Payment Integration', 'E-commerce Automation', 'Custom E-commerce Solutions', 'Performance Optimization'],
    technologies: ['Shopify', 'Shopify API', 'Liquid', 'E-Commerce', 'Payments', 'API Integration'],
  },
];

function ExpertiseCard({ expertise }) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <article className={`expertise-card${isExpanded ? ' is-expanded' : ''}`}>
      <div className="expertise-card-icon" aria-hidden="true">
        <i className={expertise.icon}></i>
      </div>
      <h3>{expertise.title}</h3>
      <p className="expertise-card-description">{expertise.description}</p>
      <div className="expertise-card-preview" aria-label="Featured capabilities">
        {expertise.capabilities.slice(0, 4).map((capability) => (
          <span key={capability}>{capability}</span>
        ))}
      </div>
      <button
        type="button"
        className="expertise-card-toggle"
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((expanded) => !expanded)}
      >
        {isExpanded ? 'Hide Details' : 'Explore Expertise'}
        <i className={`fa-solid ${isExpanded ? 'fa-arrow-up' : 'fa-arrow-right'}`} aria-hidden="true"></i>
      </button>
      {isExpanded && (
        <div className="expertise-card-details">
          <h4>Capabilities</h4>
          <ul>
            {expertise.capabilities.map((capability) => <li key={capability}>{capability}</li>)}
          </ul>
          <h4>Technology Stack</h4>
          <div className="expertise-badges">
            {expertise.technologies.map((technology) => <span key={technology}>{technology}</span>)}
          </div>
          <a className="expertise-card-cta" href="/contact">
            Talk to Our Experts <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
          </a>
        </div>
      )}
    </article>
  );
}

export default ExpertiseCard;
